// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-complete-popup p {
  padding: 1rem;
}
.registration-complete-popup button {
  margin-left: 35rem;
  margin-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderRegistrationLayout/RegistrationCompletePopup/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGE;EACE,kBAAA;EACA,gBAAA;AADJ","sourcesContent":[".registration-complete-popup {\n  p {\n    padding: 1rem;\n  }\n\n  button {\n    margin-left: 35rem;\n    margin-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
